<template>
  <div :class="classModifiers">
    <div v-if="loading" class="twittertimeline__spinner"></div>
    <div :class="contentClassModifiers">
      <div ref="init" :class="initClassModifiers"></div>
    </div>
    <div class="twittertimeline__footer" v-if="showFooter">
      <div class="twittertimeline__more-button" @click="onFooterMoreButtonClick">
        {{ getMoreTweetsLabel }}
      </div>
    </div>
    <div ref="more" class="twittertimeline__content"></div>
  </div>
</template>
<script src="./twitter-timeline.js"></script>
<style src="./twitter-timeline.scss" lang="scss"></style>
